import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCalculatedSuggestion } from "./api";
import { ISuggestions, ISuggestionsRequest } from "./model";
import { ActiveProductsByExpirationMonth } from "./shopping_cart.initial";
import { RootState } from "../RootState";

export const getSuggestedCalc = createAsyncThunk<
    ISuggestions,
    ISuggestionsRequest,
    {
        state: RootState;
    }
>('shoping_car/getSuggestedCalc', async (payload, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User; 
    return getCalculatedSuggestion(payload, token);
});

/**
 * Re-consulta suggested_calculator solo para actualizar los productos por vencer
 * al cambiar la ventana (3/6/9/12 meses). Actualiza únicamente el bucket de
 * expiración, sin recargar toda la vista ni reiniciar la selección del carrito.
 */
export const getSuggestedExpiration = createAsyncThunk<
    ActiveProductsByExpirationMonth,
    ISuggestionsRequest,
    {
        state: RootState;
    }
>('shoping_car/getSuggestedExpiration', async (payload, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User;
    const response = await getCalculatedSuggestion(payload, token);
    return response.active_products_by_expiration_month ?? {};
});
